import createLucideIcon from '../createLucideIcon';

const Text = createLucideIcon('Text', [
  ['path', { d: 'M17 6.1H3', key: 'wptmhv' }],
  ['path', { d: 'M21 12.1H3', key: '1j38uz' }],
  ['path', { d: 'M15.1 18H3', key: '1nb16a' }],
]);

export default Text;
